import React, { useState } from 'react';

function Contact({ quotes, setQuotes, language }) {
  const [name, setName] = useState('');
  const [quote, setQuote] = useState('');
  const [proof, setProof] = useState('');
  const [, setIsSubmitted] = useState(false);

  const translations = {
    ar: {
      title: 'إضافة حكمة جديدة',
      nameLabel: 'اسم الولي',
      namePlaceholder: 'أدخل اسم الولي',
      quoteLabel: 'الحكمة',
      quotePlaceholder: 'أدخل نص الحكمة هنا',
      proofLabel: 'السند والصحة',
      proofPlaceholder: 'أدخل السند أو دليل الصحة (إن وجد)',
      submitButton: 'إرسال',
      successMessage: 'تم إرسال الحكمة بنجاح، وسيتم مراجعتها وإضافتها بعد التحقق. جزاك الله خيرًا على مساهمتك!',
      embedTitle: 'حكمة جديدة',
      embedDesc: (name, quote, proof) => `**المؤلف:** ${name}\n**الحكمة:** ${quote}\n**السند والصحة:** ${proof}`,
    },
    en: {
      title: 'Add a New Wisdom Saying',
      nameLabel: 'Saint’s Name',
      namePlaceholder: 'Enter the saint’s name',
      quoteLabel: 'Wisdom',
      quotePlaceholder: 'Enter the wisdom text here',
      proofLabel: 'Chain of Transmission / Authenticity',
      proofPlaceholder: 'Enter the chain or authenticity proof (if any)',
      submitButton: 'Submit',
      successMessage: 'Wisdom submitted successfully and will be reviewed before publishing. Thank you for your contribution!',
      embedTitle: 'New Wisdom Saying',
      embedDesc: (name, quote, proof) => `**Author:** ${name}\n**Wisdom:** ${quote}\n**Proof:** ${proof}`,
    },
    fr: {
      title: 'Ajouter une Nouvelle Sagesse',
      nameLabel: 'Nom du Saint',
      namePlaceholder: 'Entrez le nom du saint',
      quoteLabel: 'Sagesse',
      quotePlaceholder: 'Entrez le texte de la sagesse ici',
      proofLabel: 'Chaîne / Authenticité',
      proofPlaceholder: 'Entrez la chaîne ou la preuve d’authenticité (si disponible)',
      submitButton: 'Envoyer',
      successMessage: 'La sagesse a été envoyée avec succès et sera vérifiée avant publication. Merci pour votre contribution !',
      embedTitle: 'Nouvelle Sagesse',
      embedDesc: (name, quote, proof) => `**Auteur :** ${name}\n**Sagesse :** ${quote}\n**Preuve :** ${proof}`,
    }
  };

  const t = translations[language] || translations.ar;

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newQuote = { quote, author: name, authenticity: proof };

    const webhookURL = 'https://discord.com/api/webhooks/1326600271446544404/eXpz-FyQZdmH4aZCeapiW8mF17-IelfyPtVadJvsKjqQUETxq2cu871e9RtLycLeRge-';

    const messagePayload = {
      embeds: [
        {
          title: t.embedTitle,
          description: t.embedDesc(name, quote, proof),
          color: 0xF5F5DC,
        },
      ],
    };

    try {
      await fetch(webhookURL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(messagePayload),
      });

      console.log('Successfully sent');

      if (Array.isArray(quotes)) {
        setQuotes([...quotes, newQuote]);
      }

      setName('');
      setQuote('');
      setProof('');
      setIsSubmitted(true);

      alert(t.successMessage);
    } catch (error) {
      console.error('Error:', error);
    }
  };

  return (
    <div className="submit-form">
      <form onSubmit={handleSubmit}>
        <h2 className="form-title">{t.title}</h2>
        <div className="form-group">
          <label htmlFor="name">{t.nameLabel}</label>
          <input
            id="name"
            type="text"
            placeholder={t.namePlaceholder}
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
            className="form-input"
          />
        </div>
        <div className="form-group">
          <label htmlFor="quote">{t.quoteLabel}</label>
          <textarea
            id="quote"
            placeholder={t.quotePlaceholder}
            value={quote}
            onChange={(e) => setQuote(e.target.value)}
            required
            className="form-textarea"
            rows="4"
          />
        </div>
        <div className="form-group">
          <label htmlFor="proof">{t.proofLabel}</label>
          <input
            id="proof"
            type="text"
            placeholder={t.proofPlaceholder}
            value={proof}
            onChange={(e) => setProof(e.target.value)}
            className="form-input"
          />
        </div>
        <button type="submit" className="submit-button">{t.submitButton}</button>
      </form>
    </div>
  );
}

export default Contact;
